import React from "react";
import { Link } from "react-router-dom";

const SectionOne = (props) => {
  const { openMod, modOpen, setMod, closeMod } = props;

  return (
    <section>
      <div className="container">
        <div className="row justify-content-center">
          <div className="text-center">
            <h1 className="ptext">
              THE AUTOMATION PLATFORM FOR <br /> E-COMMERCE BUSINESSES
            </h1>
            <p className="bigPhs">
              Automate your <span className="smallPhs"></span>
            </p>
            <div className="sectionButton">
              <button className="butn butn-sec">
                <Link to={"/login"} className="gtl">
                  <span className="gradText">Login</span>
                </Link>
              </button>
              <button className="butn butn-primary" onClick={openMod}>
                Book a Demo
              </button>
            </div>
          </div>
          <img alt="automations" className="graph" src="graph.svg" />
          <img
            alt="automations"
            className="graphMobile"
            src="graphMobile.svg"
          />
        </div>
      </div>
    </section>
  );
};

export default SectionOne;
